import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';

import { DeviceControllerService } from './../../../shared/typescript-angular-client/api/deviceController.service';

@Component({
  selector: 'app-confirm-reset-modal',
  templateUrl: './confirm-reset-modal.page.html',
  styleUrls: ['./confirm-reset-modal.page.scss'],
})
export class ConfirmResetModalPage implements OnInit {
  hasResetAction = false;
  device: any = {};
  constructor(
    private deviceApi: DeviceControllerService,
    private toast: ToastController,
    private navParams: NavParams,
    public modalController: ModalController
  ) { }

  ngOnInit(): void {
    this.device = this.navParams.get('device');
  }

  public reset(): void {
    this.hasResetAction = true;
    this.deviceApi
      .deviceControllerReset(this.device.id, { securityKey: this.device.properties.config.totpKey })
      .subscribe({
        next: (res) => {
          console.log(res);
          this.toast
            .create({
              message: 'Demande de reset prise en compte.',
              duration: 3000,
              color: 'success',
              position: 'top',
            })
            .then((toastData) => {
              this.hasResetAction = false;
              toastData.present();
              this.dismissModal();
            });
        },
        error: (error) => {
          console.log(error);
        }
      }
      );
    return;
  }

  public async dismissModal(): Promise<void> {
    this.modalController.getTop().then((modal) => {
      if (modal !== undefined) {
        modal.dismiss({ didReset: true });
      }
    });
  }
}
